/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_RetiredInputs */



/**
* | output |
* | --- |
* | "Retired" |
*
* @param {Promo_RetiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_retired = /** @type {((inputs?: Promo_RetiredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_RetiredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retirée")
	if (locale === "es") return /** @type {LocalizedString} */ ("Retirada")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Retirada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ritirata")
	return /** @type {LocalizedString} */ ("Retired")
});